var _rect, _path, _g, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReliable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F4EBFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9420_106980",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 18,
    width: 17,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 18H36.9668V38.3556H20V18Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9420_106980)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4834 19.5C27.6354 19.5 22.2854 21.384 21.6684 21.899C21.4864 22.082 21.4794 22.4 21.5184 24.529C21.5364 25.555 21.5614 26.949 21.5614 28.879C21.5614 34.08 27.2834 36.389 28.4824 36.814C29.6804 36.387 35.4054 34.065 35.4054 28.879C35.4054 26.947 35.4304 25.552 35.4494 24.526C35.4874 22.399 35.4804 22.081 35.2874 21.889C34.6824 21.384 29.3314 19.5 28.4834 19.5ZM28.4834 38.356C28.4104 38.356 28.3374 38.346 28.2664 38.324C27.9314 38.223 20.0614 35.761 20.0614 28.879C20.0614 26.962 20.0364 25.575 20.0184 24.557C19.9724 22.014 19.9624 21.484 20.6194 20.828C21.4044 20.041 27.3494 18 28.4834 18C29.6164 18 35.5614 20.041 36.3484 20.828C37.0044 21.484 36.9944 22.014 36.9484 24.554C36.9304 25.572 36.9054 26.959 36.9054 28.879C36.9054 35.761 29.0354 38.223 28.7004 38.324C28.6294 38.346 28.5564 38.356 28.4834 38.356Z",
    fill: "#5034C4"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9167 23.832L24.75 28.832H28.5L28.0833 32.1654L32.25 27.1654H28.5L28.9167 23.832Z",
    stroke: "#5034C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F9F5FF",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReliable);
export default __webpack_public_path__ + "static/media/reliable.941f8ceafb21231c46bfa66ff6355a3a.svg";
export { ForwardRef as ReactComponent };